// Thread Hub — proxy client
//
// Config comes from environment, never hardcoded. See .env.example.
// NOTE: Create React App inlines REACT_APP_* values into the built bundle at
// build time. Moving these out of source makes them CONFIGURABLE, not SECRET.
// Anything here is still readable by anyone who opens the deployed JS.
// Real secrecy has to live server-side in the proxy. See docs/SECURITY.md.

const PROXY_URL =
  process.env.REACT_APP_PROXY_URL ||
  "https://thread-proxy.netlify.app/.netlify/functions/airtable";
const PROXY_KEY = process.env.REACT_APP_PROXY_KEY;
const BASE_ID = process.env.REACT_APP_BASE_ID;
const TABLE_NAME = process.env.REACT_APP_TABLE_NAME || "Engagements";

if (!PROXY_KEY || !BASE_ID) {
  // Fail loudly at boot rather than silently 401-ing on first call.
  console.error(
    "[Thread Hub] Missing config. Copy .env.example to .env and fill in " +
      "REACT_APP_PROXY_KEY and REACT_APP_BASE_ID before building."
  );
}

export async function proxyCall(payload) {
  const res = await fetch(PROXY_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Thread-Key": PROXY_KEY,
    },
    body: JSON.stringify({
      ...payload,
      baseId: payload.baseId || BASE_ID,
      tableName: payload.tableName || TABLE_NAME,
    }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Proxy error: ${res.status}`);
  }
  return res.json();
}

